var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.circle)?_c('i',{staticClass:"icon icon--circle"},[_c('span',{staticClass:"icon__inner",class:_vm.innerClasses}),_vm._v(" "),_c(_vm.name,{tag:"component",class:[
      _vm.classes,
    ]})],1):_c(_vm.name,_vm._b({tag:"component",class:[
    'icon',
    _vm.classes,
  ]},'component',_vm.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }